<script setup>
import { router } from '@inertiajs/vue3'
import AppLayout from '@/Layouts/AppLayout.vue'
import { Button } from '@/Components/ui/button'
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from '@/Components/ui/card'
import { Badge } from '@/Components/ui/badge'

defineProps({
  count: Number
})

function increment() {
  router.post('/inertia/increment')
}
</script>

<template>
  <AppLayout>
    <div class="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div class="max-w-md mx-auto">
        <Card>
          <CardHeader>
            <CardTitle class="flex items-center justify-between">
              Counter
              <Badge variant="secondary">Demo</Badge>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div class="text-center py-8">
              <span class="text-6xl font-black text-blue-600">{{ count }}</span>
              <p class="text-muted-foreground mt-2">Current Count</p>
            </div>
          </CardContent>
          <CardFooter class="flex justify-center">
            <Button 
              @click="increment" 
              size="lg"
              class="w-full bg-blue-600 hover:bg-blue-700"
            >
              Increment
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  </AppLayout>
</template>
